import React, { useEffect, useState } from 'react';
import { apiGet } from '../utils/api';
// import { useNavigate } from 'react-router-dom';
import { LoadingComponent } from '../components';
import { AdAccounts } from '../constants/AdAccounts';
import { BORDER_COLORS_FOR_LOGOS } from '../constants/LogoBorderColors';
import { LOGO_IMAGES } from '../constants/LogoImages';
import { useNotify } from '../components/NotificationComponent';
import { connectAccountHelp } from '../assets/images';

export default function ConnectedAccountsPage() {
  // const navigate = useNavigate();
  const { notify } = useNotify();
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCustomGoolgeSteps, setShowCustomGoogleSteps] = useState(false)
  const platformLinks = {
    'Google Ads':"auth/google/",
    'Meta':"auth/meta/",
    'LinkedIn':"auth/linkedin/",
    'Twitter':"auth/x/",
  }

  useEffect(() => {
    fetchAccounts();
  }, []);

  const fetchAccounts = async () => {
    try {
      const res = await apiGet('ad-accounts/');
      setAccounts(res);
      setLoading(false);
    } catch (err) {
      console.error('Failed to fetch ad accounts', err);
      setLoading(false);
    }
  };

  const handleConnect = (platform) => {
    const url = platformLinks[platform]
    if(!url) return
    apiGet(url).then(res => {
      console.log(res)
      window.location.href = res.auth_url
    }).catch(err => {
      notify(err)
    })
  };

   useEffect(()=>{
      const url_string = window.location.href
      var url = new URL(url_string);
      var invite_status = url.searchParams.get("invite_status");
      if(invite_status){
        localStorage.setItem('invite_status', invite_status)
        const newUrl = `${window.location.origin}/connected-accounts`;
        window.location.replace(newUrl);
      }

      // when navigated back again to this page
      const status = localStorage.getItem('invite_status')
      if(status){
        if (status === 'FAILED'){
          notify("Please contact admin, something went wrong")
          setShowCustomGoogleSteps(true)
          return
        }
        else if(status === 'PENDING'){
          notify('Invitation has been sent to you please follow the steps and accept the invitation')
          setShowCustomGoogleSteps(true)
          return
        }
        else if(status === 'ALREADY_LINKED'){
          notify('Huuraah ! account linked successfully')
          localStorage.removeItem('invite_status')
          setShowCustomGoogleSteps(false)
          return
        }
      }
      // eslint-disable-next-line
    },[])

  if (loading) {
     return <div className="min-h-[85vh] flex flex-col justify-center items-center text-center py-10">
          <LoadingComponent className='border-blue-500 h-8 w-8'/>
          <p className='my-2'>Loading account info...</p>
      </div>;
  }

  return (
    <div className="max-w-4xl mx-auto py-20 px-6">
      <h2 className="text-3xl py-8 font-bold text-gray-800 mb-8">Connected Ad Accounts</h2>

      <div className="space-y-6">
        {accounts.length === 0 && (
          <div className="text-black/80 font-semibold text-center my-20">No accounts connected yet.</div>
        )}

        {accounts.map((acc) => (
          <div key={acc.id} className="flex justify-between items-center bg-white p-6 rounded-xl shadow-md">
            <div>
              <div className="font-semibold">{acc.platform.toUpperCase()}</div>
              <div className="text-gray-500 text-sm">Account ID: {acc.account_id}</div>
            </div>
            <button
              onClick={() => alert('Disconnect flow coming')}
              className="text-red-500 font-semibold hover:underline"
            >
              Disconnect
            </button>
          </div>
        ))}
      </div>

      {showCustomGoolgeSteps &&
        <div className='bg-gray-500/20 p-4 my-5 rounded-md'>
          <p className='my-2'>Step 1: Visit <a className='text-purple-700' target='_blank' rel='noreferrer' href='https://ads.google.com'>ads.google.com</a></p>
          <p className='my-2'>Step 2: Go to 'Admin' <span className='text-[14px] text-gray-400 px-2'>&gt;&gt;</span> 'Access and Security'</p>
          <p className='my-2'>Step 3: Accept the invitation</p>
          <p className='my-2'>Step 4. Try connecting google ads again here and your account will be connected.</p>
          <img className='rounded-md mt-8' src={connectAccountHelp} alt='connected account help' />
        </div>
      }

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
        {AdAccounts.map((platform) => (
          <div className='relative'>
            <button
              key={platform}
              onClick={() => handleConnect(platform)}
              className={`flex justify-center items-center w-full py-3 rounded-xl font-semibold border-l-4`}
              style={{ borderColor: BORDER_COLORS_FOR_LOGOS[platform] }}
            >
              <div style={{ opacity:0.6,boxShadow:`0px 0px 3px ${BORDER_COLORS_FOR_LOGOS[platform]}`}} className='absolute w-full h-full rounded-xl font-bold '/>
              <img src={LOGO_IMAGES[platform]} alt={platform} className='h-6 w-6 z-30'/>
              <p className='ml-1 z-10 text-black'>Connect {platform?.charAt(0)?.toUpperCase() + platform?.slice(1)}</p>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
